import { PatientInfo } from '../../ts';
import { defaultSelectedPatient } from './default-selected-patient';

export const notFoundPatient: PatientInfo = {
  ...defaultSelectedPatient,
  id: '-1',
};
